define([
    "jquery",
    "underscore",
    "marionette",
    "views/withdrawal/common_view",
    "forms/withdrawal/payda_form"
], function($, _, Marionette, CommonView, PaydaForm) {
    return CommonView.extend({

        ui: _.extend(CommonView.prototype.ui, {
            'currencySelect':'#currency_abbr',
            'amount' : '#amount',
            'paydaRules' : '#payda_rules',

            'withdrawal': 'withdrawal_btn'
        }),

        events: _.extend(CommonView.prototype.events, {
            'keyup @ui.amount': 'amountValidation',
            'change @ui.accountNoSelect': function(e){
                this.updateFinancial();
             }
        }),

        initialize: function(){
            this.bindUIElements();
            this.updateFinancial();
            $(this.ui.paydaRules).modal('show');
            this.form = new PaydaForm();

            if(window.form_error)
            {
                this.triggerMethod('show:errors', window.form_error);
                window.form_error = null;
            }
        },

        amountValidation: function() {
            if(this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(function () {
                const usd = $('#amount').val();
                if (isNaN(usd) || usd === '' || !usd) {
                    $('#expected_amount').val('-');
                    return;
                }

                $.ajax({
                    url: `/rest_withdrawal/payda_withdrawal_rate?usd=${usd}`,
                    type: 'GET',
                    success: function (data) {
                        if (!data.withdrawal_rated_amount)
                        {
                            if(usd < Number(data.withdrawal_minimum_amount))
                            {
                                $('#expected_amount').text('-');
                                $('#withdrawal_btn').attr('disabled', true);
                                $('#error_amount').text(data.message_min_amount);
                            }
                            else
                            {
                                $('#expected_amount').text('-');
                                $('#withdrawal_btn').attr('disabled', true);
                                $('#error_amount').text('');
                            }
                            return;
                        }

                        if(!data.withdrawal_info_yearly.is_withdrawalable)
                        {
                            $('#expected_amount').text(data.withdrawal_rated_amount);
                            $('#withdrawal_btn').attr('disabled', true);
                            if (data.withdrawal_info_yearly.is_simple_member)
                            {
                                $('#error_amount').text(data.message_simple_limit);
                            }
                            else
                            {
                                $('#error_amount').text(data.message_annual_limit);
                            }

                            return;
                        }

                        if(!data.withdrawal_info_daily.is_withdrawalable)
                        {
                            $('#expected_amount').text(data.withdrawal_rated_amount);
                            $('#withdrawal_btn').attr('disabled', true);
                            if (data.withdrawal_info_daily.is_simple_member)
                            {
                                $('#error_amount').text(data.message_simple_limit);
                            }
                            else
                            {
                                $('#error_amount').text(data.message_daily_limit);
                            }

                            return;
                        }

                        if(usd >= Number(data.withdrawal_minimum_amount))
                        {
                            $('#expected_amount').text('₩' + data.withdrawal_rated_amount);
                            if (data.withdrawal_info_daily.is_simple_member && !data.withdrawal_info_daily.is_withdrawalable) {
                                $('#withdrawal_btn').attr('disabled', true);
                                $('#error_amount').text(data.message_simple_limit);
                            } else {
                                $('#withdrawal_btn').attr('disabled', false);
                                $('#error_amount').text('');
                            }
                            return;
                        }
                        else if(usd < Number(data.withdrawal_minimum_amount))
                        {
                            $('#expected_amount').text('-');
                            $('#withdrawal_btn').attr('disabled', true);
                            $('#error_amount').text(data.message_min_amount);
                            return;
                        }
                    },
                });
            }, 300);
        },
    });
});
